export const ROUTES = {

  HOME: "/",
  DATAPROCESSING: "/dataprocessing",
  CREATESESSION: "/createsession", // sub-route of dataprocessing
  TRACKSESSION: "/tracksession", // sub-route of dataprocessing
  ACCOUNT: "/account",

};

export const EXTERNAL_LINKS = {
  IMETALAB_HOME: "http://imetalab.ca",
  IMETALAB_ABOUT: "http://imetalab.ca/about",
  IMETALAB_RESOURCE: "http://wiki.imetalab.ca",
  IMETALAB_CONTACT: "https://groups.google.com/forum/#!forum/lovemetalab",
  IMETALAB_TERMS: "http://imetalab.ca/terms.html",
  IMETALAB_SHINY: "http://shiny.imetalab.ca",
  IMETALAB_ACCOUNT: "http://account.imetalab.ca",
  IMETALAB_METAMAP: "http://shiny.imetalab.ca/metalab_report/", //report page
};

export const SERVER_APIS = {
  // SERVER_URL: 'http://localhost', // for local development ONLY
  SERVER_URL: 'http://session.imetalab.ca', // for production ONLY
  AUTHENTICATE_SESSION: `/id_authenticate_session.php`, // generate a valid session and forward the session ID to provided email address
  CREATE_SESSION: `/email_create_session.php`, // authenticate a session through a valid session ID
  FETCH_RAWFILELIST: `/temp_filelist.php`, // retrieve raw file list for a session
  UPLOAD_RAWFILES: `/upload_raw_session.php`, // upload raw files
  INIT_SESSION: `/init_metalab_exe.php`,
  EXEC_SESSION: `/start_metalab_exe.php`,
  UPDATE_SESSION: `/progress_update.php`, //update session progress
  DOWNLOAD_SESSION: `/download_as_zip.php?id=`, //download all session results as .zip
  RENDER_BARCHART: `/pylo/barchart.php?sess_id=`, // NOT implemented
  RENDER_TREECHART: `/pylo/treechart.php?sess_id=`, // NOT implemented
  RENDER_PIECHART: `/pylo/piechart.php?sess_id=`, // NOT implemented

  DOWNLOAD_FILE: `/download_file.php?id=`, // download individual file
  DOWNLOAD_RESULT: `/download_result.php`, //download result/combined folder
  DOWNLOAD_FUNCTION: `/download_function.php`, //download function_annotation folder
  DOWNLOAD_TAXONOMY: `/download_taxonomy.php`, //download taxonomy_analysis folder
  DOWNLOAD_REPORT: `/download_report.php`, //download report folder
  VIEW_REPORT: `/view_report.php`, //view report folder inside browser, not working

  DOWNLOAD_ZIP: `/download_as_zip.php?id=`, // download all as zip
  DOWNLOAD_SELECTED: `/download_selection_as_zip.php`, // download selected files
  
}